import { SellerRatingState } from '@gumtree/shared/src/model/seller-rating.model';
import { AD } from '@gumtree/shared/src/model/generic.model';

export type State = SellerRatingState;

const initialState: State = {
    total: 0,
    average: 0,
    topTips: '',
    bottomTips: '',
    type: '',
    breakdown: {},
    formattedAverage: '',
    contactName: '',
    accountPublicId: '',
};

export const UPDATE_RATING = 'UPDATE_RATING';

export const updateRating: AD<typeof UPDATE_RATING, Partial<State>> = (payload) => ({
    type: UPDATE_RATING,
    payload,
});

export default (state: State = initialState, action): State =>
    action.type === UPDATE_RATING ? { ...state, ...action.payload } : state;
